<template>
  <v-dialog
    v-model="show"
    @click:outside="close"
    width="500"
    @keydown.esc="close"
  >
    <v-card :loading="status == 'loading'">
      <v-toolbar color="red" dark flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="pt-10 text-center">
        <p>{{ description }}</p>
      </v-card-text>

      <v-card-actions>
        <v-row style="padding: 0; margin: 0">
          <v-col class="text-center" style="padding: 0; margin: 0">
            <v-btn
              color="gray"
              rounded
              elevation="0"
              @click="close"
              class="mr-5"
              >Cancelar
            </v-btn>

            <v-btn
              color="primary"
              rounded
              elevation="0"
              @click="submit"
              :loading="status == 'loading'"
              >Confirmar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";

export default {
  props: ["title", "description", "show", "hide", "submit"],
  created() {},
  computed: {
    ...mapState({
      status: (state) => state.Users.status,
    }),
  },
  data() {
    return {
      complete_message: "",
      user: {
        email: "",
      },
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    close() {
      this.hide();
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
  },
};
</script>
